import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, memo } from 'react';
import { resolveUrlByEnvironment } from '../../utils';
import styles from './styles.module.scss';
export const MessengerPreview = memo(forwardRef(({ className, isLeftMenuOpen, onLoad }, ref) => {
    const cn = classNames(styles.root, className, {
        [styles.rootWithLeftMenuOpen]: isLeftMenuOpen,
    });
    return (_jsx("iframe", { ref: ref, frameBorder: "0", className: cn, onLoad: onLoad, src: resolveUrlByEnvironment({
            production: 'https://messenger.dixa.io/landing-page-preview.html',
            staging1: 'https://messenger.stag.dixa.io/landing-page-preview.html',
            staging2: 'https://messenger.stag2.dixa.io/landing-page-preview.html',
            staging3: 'https://messenger.stag3.dixa.io/landing-page-preview.html',
        }) }));
}));
MessengerPreview.displayName = 'MessengerPreview';
